import { getQueryParameter } from './url';
import { isNewRelicLoggingEnabled } from '../settings';

export function logError(error: Error, contextMessage?: string) {
  if (!error) {
    error = new Error();
  }

  if (contextMessage !== undefined) {
    error.message = `${contextMessage} - ${error.message}`;
  }

  if (isNewRelicLoggingEnabled()) {
    newrelic.noticeError(error);
  }

  const debugMode = Boolean(getQueryParameter('debug'));
  // always log errors to console in non-prod or if debugMode is enabled
  if (process.env.NODE_ENV !== 'production' || debugMode) {
    console.error(error);
  }
}

/**
 * Logs a user-interaction (like Button:Clicked) to NewRelic in production or to the console in dev
 * Use &debug=1 to additionally log actions to the console in production
 * @param pageSection e.g. ProductCarousel
 * @param componentName e.g. SlideImage
 * @param actionName e.g. Clicked
 * @param customAttributes optional e.g. { sku: 'SKU-12345' }
 */
export function logAction(
  pageSection: string,
  componentName: string,
  actionName: string,
  customAttributes?: { [key: string]: string | number }, // string | number to keep our data simple; technically we could accept more complex data
) {
  const action = `${pageSection}:${componentName}:${actionName}`;

  if (isNewRelicLoggingEnabled()) {
    newrelic.addPageAction(action, customAttributes);
  }

  const debugMode = Boolean(getQueryParameter('debug'));
  // always log actions to console in non-prod or if debugMode is enabled
  if (process.env.NODE_ENV !== 'production' || debugMode) {
    console.info(action, customAttributes);
  }
}

/**
 * Logs an event (like ProjectCreated) to NewRelic in production or to the console in dev
 * Use &debug=1 to additionally log actions to the console in production
 * @param eventName e.g. PageReady or ProjectCreated
 * @param customAttributes optional e.g. { projectId: 'abcd-1234-efgh-5678' }
 */
export function logEvent(eventName: string, customAttributes?: { [key: string]: string | number }) {
  const action = `Event:${eventName}`;

  if (isNewRelicLoggingEnabled()) {
    newrelic.addPageAction(action, customAttributes);
  }

  const debugMode = Boolean(getQueryParameter('debug'));
  // always log actions to console in non-prod or if debugMode is enabled
  if (process.env.NODE_ENV !== 'production' || debugMode) {
    console.info(action, customAttributes || '');
  }
}
